import RpcService from "@/core/services/Rpc/RpcService";
import Company from "@/domains/Companies/Company";
import RpcResponse from "@/core/services/Rpc/RpcResponse";
import type RpcDataPagination from "@/core/services/Rpc/RpcDataPagination";
import type RpcDataSort from "@/core/services/Rpc/RpcDataSort";

/**
 * DAO для работы с компаниями
 */
class CompaniesDAO {

    static async get(id: number): Promise<RpcResponse> {
        return await RpcService.makeRequest('companies.get', { id });
    }

    static async getList(
      filters?: {
        partnerId?: number,
        pattern?: string,
        isSeller?: boolean,
        isBuyer?: boolean
      },
      pagination?: RpcDataPagination,
      sort?: RpcDataSort,
    ): Promise<RpcResponse> {
        return await RpcService.makeRequest(
          'companies.getList',
          {
            ...filters,
          },
          pagination,
          sort
        );
    }

    static async add(company: Company, partnerId?: number): Promise<RpcResponse> {
        return await RpcService.makeRequest('companies.add', {
            company,
            partnerId
        });
    }

    static async update(company: Company): Promise<RpcResponse> {
        return await RpcService.makeRequest('companies.update', { company });
    }

    static async delete(id: number): Promise<RpcResponse> {
        return await RpcService.makeRequest('companies.delete', { id });
    }

}

export default CompaniesDAO;
